type SavedListener = (message?: string) => void;
const listeners = new Set<SavedListener>();

export function subscribeSaved(listener: SavedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Trigger the debounced "Saved" indicator in the bottom right.
 */
export function notifySaved(message = "Saved"): void {
  listeners.forEach((l) => l(message));
}

export function useNotifySaved() {
  return (message = "Saved") => notifySaved(message);
}
